import LayoutSourcing from "@/app/common-modules/layout/LayoutSourcing";
export default [
  {
    // 寻源弹框页面
    path: "/sourcingFlow",
    component: LayoutSourcing,
    redirect: "/sourcingFlow",
    children: [
      {
        path: "/sourcingFlow",
        component: () => import("@/app/sourcingFlow/views/sourcingFlow.vue"),
        name: "sourcingFlow",
        title: "首页",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/expertsIn",
        component: () =>
          import("@/app/sourcingFlow/views/expertsIn/expertsIn.vue"),
        name: "expertsIn",
        title: "专家签到",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/expertSign",
        component: () =>
          import("@/app/sourcingFlow/views/expertsIn/expertSign.vue"),
        name: "expertSign",
        title: "专家重置签名",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/letterCommitmentConfirm",
        component: () =>
          import(
            "@/app/sourcingFlow/views/letterCommitmentConfirm/letterCommitmentConfirm.vue"
          ),
        name: "letterCommitmentConfirm",
        title: "承诺书确认",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/bidOpenSituation",
        component: () =>
          import(
            "@/app/sourcingFlow/views/bidOpenSituation/bidOpenSituation.vue"
          ),
        name: "bidOpenSituation",
        title: "开标情况",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/scoreScaleDeveloped",
        component: () =>
          import(
            "@/app/sourcingFlow/views/scoreScaleDeveloped/scoreScaleDeveloped.vue"
          ),
        name: "scoreScaleDeveloped",
        title: "评分表制定",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/viewScoreItems",
        component: () =>
          import("@/app/sourcingFlow/views/viewScoreItems/viewScoreItems.vue"),
        name: "viewScoreItems",
        title: "评分项查看",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/supplierComplianceInspection",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierComplianceInspection/supplierComplianceInspection.vue"
          ),
        name: "supplierComplianceInspection",
        title: "分包商符合性检查",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/supplierComplianceInspectionWZ",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierComplianceInspection/supplierComplianceInspectionWZ.vue"
          ),
        name: "supplierComplianceInspectionWZ",
        title: "分包商符合性检查",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/supplierComplianceInspectionWZCG",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierComplianceInspection/supplierComplianceInspectionWZCG.vue"
          ),
        name: "supplierComplianceInspectionWZCG",
        title: "分包商符合性检查",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/issueClarificationNotice",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierIssueClarification/issueClarificationNotice.vue"
          ),
        name: "issueClarificationNotice",
        title: "发布澄清通知列表",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/addIssueClarificationNotice",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierIssueClarification/addIssueClarificationNotice.vue"
          ),
        name: "addIssueClarificationNotice",
        title: "发布澄清通知", // 查看澄清通知 // 查看澄清函内容
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/supplierClarificationLetter",
        component: () =>
          import(
            "@/app/sourcingFlow/views/supplierIssueClarification/supplierClarificationLetter.vue"
          ),
        name: "supplierClarificationLetter",
        title: "分包商澄清函",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/skiiScore",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/skiiScore.vue"),
        name: "skiiScore",
        title: "技术评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/skiiScoreWZ",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/skiiScoreWZ.vue"),
        name: "skiiScoreWZ",
        title: "技术评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/addSkiiScore",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/addSkiiScore.vue"),
        name: "addSkiiScore",
        title: "新增/编辑技术评分", // 无评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/skiiScoreList",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/skiiScoreList.vue"),
        name: "skiiScoreList",
        title: "技术评分列表", // 已有评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/addSkiiScoreWZ",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/addSkiiScoreWZ.vue"),
        name: "addSkiiScoreWZ",
        title: "新增/编辑技术评分", // 无评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/skiiScoreListWZ",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/skiiScoreListWZ.vue"),
        name: "skiiScoreListWZ",
        title: "技术评分列表", // 已有评分数据
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/commercialGrade",
        component: () =>
          import("@/app/sourcingFlow/views/expertEvaluate/commercialGrade.vue"),
        name: "commercialGrade",
        title: "商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/commercialGradeWZ",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/commercialGradeWZ.vue"
          ),
        name: "commercialGradeWZ",
        title: "商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/addCommercialGrade",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/addCommercialGrade.vue"
          ),
        name: "addCommercialGrade",
        title: "新增/编辑商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/commercialGradeList",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/commercialGradeList.vue"
          ),
        name: "commercialGradeList",
        title: "商务评分/技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/addCommercialGradeWZ",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/addCommercialGradeWZ.vue"
          ),
        name: "addCommercialGradeWZ",
        title: "新增/编辑商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/commercialGradeListWZ",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/commercialGradeListWZ.vue"
          ),
        name: "commercialGradeListWZ",
        title: "商务评分/技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/technicalScoreSummary",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/technicalScoreSummary.vue"
          ),
        name: "technicalScoreSummary",
        title: "技术评分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/summaryBusinessSkillsScores",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/summaryBusinessSkillsScores.vue"
          ),
        name: "summaryBusinessSkillsScores",
        title: "商务技术评分汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/operateSkillOrCommonSummary",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/operateSkillOrCommonSummary.vue"
          ),
        name: "operateSkillOrCommonSummary",
        title: "技术汇总/商务技术汇总",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/technicalBusinessScore",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/technicalBusinessScore.vue"
          ),
        name: "technicalBusinessScore",
        title: "技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/technicalBusinessScoreWZ",
        component: () =>
          import(
            "@/app/sourcingFlow/views/expertEvaluate/technicalBusinessScoreWZ.vue"
          ),
        name: "technicalBusinessScoreWZ",
        title: "技术商务评分",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/bidEvaluationReportPreparation",
        component: () =>
          import(
            "@/app/sourcingFlow/views/bidEvaluationReport/bidEvaluationReportPreparation.vue"
          ),
        name: "bidEvaluationReportPreparation",
        title: "评标报告编制",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/bidEvaluationReportConfirm",
        component: () =>
          import(
            "@/app/sourcingFlow/views/bidEvaluationReport/bidEvaluationReportConfirm.vue"
          ),
        name: "bidEvaluationReportConfirm",
        title: "评标报告确认",
        meta: {
          hide_nav_bar: true
        }
      },
      {
        path: "/relationship",
        component: () => import("@/app/sourcingFlow/views/relationship.vue"),
        name: "relationship",
        title: "企业关系查询",
        meta: {
          hide_nav_bar: false
        }
      }
    ]
  }
];
